import { registerModule } from "../module.register";
import { posRoutes } from "./pos.routes";
import { posService } from "../../services/pos.service";

registerModule(() => ({
  name: "pos",
  routes: posRoutes,
  services: {
    posService: () => Promise.resolve(posService),
  },
  dependencies: ["auth"],
}));
